// const API_URL = `http://localhost/one_backoffice/api/v1/user`;
const API_URL = `${process.env.REACT_APP_BACKOFFICE}/api/v1/user`;

class AuthThaID {
  login(token) {
    return fetch(API_URL, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then(function(response) {

        if (response.status === 401) {
          return response.json();
        }

        if (response.status === 422) {
          throw new Error('ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง');
        }

        return response.json();

      })
      .then((response) => {
        console.log('thaid', response.data);
        if ( response.success !== undefined && response.success === false) {
          
          throw new Error(response.message);
        }

        // if (response.data.token.access_token) {
        //   localStorage.setItem('user', JSON.stringify(response.data));
        // }
        if (response.success) {
          const data = {
            profile: response.data,
            token: {
              access_token: token
            }
          }
          localStorage.setItem('user', JSON.stringify(data));
        }

        return response;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  getCurrentRole() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user !== null ? user.profile.user_type.id : false;
  }

  isLogin() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user !== null;
  }
}

export default new AuthThaID();
